angular.module('ui.omStat', [])
    .directive('omStat', function ($timeout, customTemplateResolver) {

        return {
            restrict: 'EA',
            scope: {
                items: '=items',
                customItems: '=customItems'
            }, // use a new isolated scope
            template: customTemplateResolver.get('omStat.html', 'app/ui/omStat/omStat.html'),
            controller: 'OmStatController'
        };

    })

    .directive('honeyButton', function ($timeout, customTemplateResolver) {

        return {
            restrict: 'EA',
            bindToController: true,
            scope: {
                color: '@',
                arrowUp: '@',
                arrowDown: '@',
                targetUri: '@',
                iconName: '@',
                title: '@',
                label: '@'
            }, // use a new isolated scope
            template: customTemplateResolver.get('honeyButton.html', 'app/ui/omStat/honeyButton.html'),
            controller: 'HoneyButtonController'
        };
    })
    .controller('HoneyButtonController', function HoneyButtonController($scope, $window, $element, colorService) {

        //set the title to be at least '&nbsp;' when it's empty
        //the special space symbol (alt+255) entered in the string here, will
        //be converted by angular into 'nbsp;'
        $scope.titleInternal = !$scope.title ? ' ' : $scope.title;

        //Dynamically update font-size value depending on the length of the title
        var getFontSize = function(textLength) {
            if (textLength <= 12) return '0.7em';
            if (textLength <= 19) return '0.65em';
            if (textLength <= 23) return '0.55em';

            return '0.4em';
        };
        $scope.fontStyle = { 'font-size': getFontSize($scope.titleInternal.length) };

        $scope.openTargetUri = function () {
            $window.location = $scope.targetUri;
        };

        var arrowUp = $scope.$eval($scope.arrowUp);
        var arrowDown = $scope.$eval($scope.arrowDown);
        var arrowSuffix = !!arrowUp ? '-up' : (!!arrowDown ? '-down' : '');
        var colorSuffix = $scope.color ? $scope.color : 'grey';
        
        $scope.dynamicStyle = {
            'background-image': 'url(\'assets/images/honeycomb-' + colorSuffix + arrowSuffix + '.png\')'
        };

        initController();

        function initController() {
            //Get the current accent color from the parent button wrap element and calculate apropriate filter element value
            //to set onto customer filter property, which will be used by the pseudo element 'before' to apply
            //this filter to modify the default black hexagonal lines to match the current Brand's accent color

            //Get the button wrap reference which holds the custom property with the filter value and accent color value
            //Once we set the calculated filter to this property, it will be applied on the 'before' pseudo element
            //as it uses this custom property for its filter value
            var buttonWrap = $element.closest('.om-Honey-Button-Wrap');

            if (buttonWrap.length > 0) {
                //Get current accent color defined in the omStat.less head section
                var accentColor = _.str.trim(getComputedStyle(document.documentElement).getPropertyValue('--accent-color'));
                if (accentColor) {
                    //Calculate filter value from accent color
                    var filterValue = colorService.getFiltersToTransformBlackToColor(accentColor);
            
                    //And finally set updated filter to match current accent color
                    document.styleSheets[0].addRule('.om-Honey-Button-Wrap .om-Stat-Honey-Button:after', `filter:${filterValue};`);
                }
            }
        }
    })

    .directive('bookmarkButton', function ($timeout, customTemplateResolver) {

        return {
            restrict: 'EA',
            bindToController: true,
            scope: {
                color: '@',
                targetUri: '@',
                iconName: '@',
                title: '@',
                label: '@'
            }, // use a new isolated scope
            template: customTemplateResolver.get('bookmarkButton.html', 'app/ui/omStat/bookmarkButton.html'),
            controller: 'BookmarkButtonController'
        };

    })
    .controller('BookmarkButtonController', function BookmarkButtonController($scope, $window, $element, colorService) {

        initController();

        function initController() {
            //Get the current accent color from the parent button wrap element and calculate apropriate filter element value
            //to set onto customer filter property, which will be used by the pseudo element 'before' to apply
            //this filter to modify the default black hexagonal lines to match the current Brand's accent color

            //Get the button wrap reference which holds the custom property with the filter value and accent color value
            //Once we set the calculated filter to this property, it will be applied on the 'before' pseudo element
            //as it uses this custom property for its filter value
            var buttonWrap = $element.closest('.om-Stat-Bookmark-Button-Wrap');
            if (buttonWrap.length > 0) {
                //Get current accent color defined in the omStat.less head section
                var accentColor = _.str.trim(getComputedStyle(document.documentElement).getPropertyValue('--accent-color'));
                if (accentColor) {
                    //Calculate filter value from accent color
                    var filterValue = colorService.getFiltersToTransformBlackToColor(accentColor);
            
                    //And finally set updated filter to match current accent color
                    document.styleSheets[0].addRule('.om-Stat-Bookmark-Button-Wrap:before', `filter:${filterValue};`);
                }
            }
        }

        $scope.openTargetUri = function () {
            $window.location = $scope.targetUri;
        };
    })

    .controller('OmStatController', function OmStatController($scope) {

        //The controller code executes before the compilation of the template (rendering)
        //var items = $scope.items;

    })

;
